var map = {
	"./体检01.png": 2927,
	"./体检02.png": 2928,
	"./体检03.png": 2929,
	"./体检04.png": 2930,
	"./体检05.png": 2931,
	"./卡01.png": 2932,
	"./卡02.png": 2933,
	"./卡03.png": 2934,
	"./卡04.png": 2935,
	"./卡05.png": 2936,
	"./宿舍01.png": 2937,
	"./宿舍02.png": 2938,
	"./宿舍03.png": 2939,
	"./宿舍04.png": 2940,
	"./宿舍05.png": 2941,
	"./打印01.png": 2942,
	"./打印02.png": 2943,
	"./打印03.png": 2944,
	"./打印04.png": 2945,
	"./打印05.png": 2946,
	"./报到01.png": 2947,
	"./报到02.png": 2948,
	"./报到03.png": 2949,
	"./报到04.png": 2950,
	"./报到05.png": 2951,
	"./校服01.png": 2952,
	"./校服02.png": 2953,
	"./校服03.png": 2954,
	"./校服04.png": 2955,
	"./校服05.png": 2956,
	"./缴费01.png": 2957,
	"./缴费02.png": 2958,
	"./缴费03.png": 2959,
	"./缴费04.png": 2960,
	"./缴费05.png": 2961,
	"./通道01.png": 2962,
	"./通道02.png": 2963,
	"./通道03.png": 2964,
	"./通道04.png": 2965,
	"./通道05.png": 2966
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3059;


//////////////////
// WEBPACK FOOTER
// ./styles/images/user/grey (\.gif|\.jpeg|\.png|\.jpg|\.bmp)
// module id = 3059
// module chunks = 0